import BaseScene from "./BaseScene";
import LabelButton from "../components/LabelButton";

import TestJSON from '../../assets/tests/test.json'


import TestJPG from '../../assets/tests/test.jpg'
import TestPNG from '../../assets/tests/test.png'
import TestSVG from '../../assets/tests/test.svg'


import TestWav from '../../assets/tests/test.wav'
import TestMP3 from '../../assets/tests/test.mp3'
import Testm4a from '../../assets/tests/test.m4a'

import TestMP4 from '../../assets/tests/test.mp4'
import TestWebM from '../../assets/tests/test.webm'


import TestTTF from '../../assets/tests/test.ttf'
import TestWOFF from '../../assets/tests/test.woff'
import TestWOFF2 from '../../assets/tests/test.woff2'
import TestOTF from '../../assets/tests/test.otf'



import TestOGG from '../../assets/tests/test.ogg'
import TestAAC from '../../assets/tests/test.aac'
import TestXML from '../../assets/tests/test.xml'


import LogoSponge from '../../assets/tests/sponge-logo-sporange.png'
import LogoPhaser3 from '../../assets/tests/phaser3-logo.png'


export interface TestResult {
   success: boolean;
   info: any;
}

/**
 *
 * @category scenes
 * @export
 * @class TestScene
 * @extends {BaseScene}
 */
export default class TestScene extends BaseScene {

   private _complete: boolean = false;
   private _results: { [key: string]: TestResult } = {};

   private loadTests: { [key: string]: boolean } = {};

   private _benchmarkCounter: number = 0;

   private _dogs: Phaser.GameObjects.Container;

   private _benchMarkNumbers: { quantity: number; scale: number }[] = [{ quantity: 64, scale: 1 }, { quantity: 256, scale: 0.5 }, { quantity: 1024, scale: 0.25 }];
   private _fps: number[] = [];
   private benchmarkEvent: any;
   private _benchmarkTimer: number = 0;

   private resultsText: Phaser.GameObjects.Text;
   startButton: LabelButton | undefined;

   // dat.GUI is avalible if you want to add to quickly change properties..
   // private _gui: dat.GUI = new GUI();

   constructor() {
      super({
         key: "TestScene",
         active: false // false means this state isn't loaded on boot. true means its instantly activated.
      });
      console.log("TestScene::constructor");
   }

   preload(): void {
      super.preload();
      console.log("TestScene::preload");

      this.load.on('filecomplete', () => {
         //on load and processed file complete
      });
      this.load.on('load', (file: Phaser.Loader.File) => {
         //on load of 1 file
         this.loadTests[file.key] = true;

      });
      this.load.on('loaderror', (file: Phaser.Loader.File) => {
         //on a file not successfully loading.
         this.loadTests[file.key] = false;


      });


      this.load.audio('mp3', TestMP3);

      //test image loading
      this.load.image([
         { key: 'png', url: TestPNG },
         { key: 'logo-sponge', url: LogoSponge },
         { key: 'logo-phaser', url: LogoPhaser3 },


      ]);


      this._results.url = {
         success: true,
         info: window.location
      }
   }

   create(): void {
      // this.showPopup();

      this.startButton = new LabelButton(this, this.cameras.main.width / 2, this.cameras.main.height / 2, "start", () => {
         console.log("Running tests");
         this.startTest();
      });



      new LabelButton(this, this.cameras.main.width / 2, this.cameras.main.height / 2 + 200, "VO 1", () => {
         this.sponge.startVO("1",this);
      });

      new LabelButton(this, this.cameras.main.width / 2, this.cameras.main.height / 2 + 300, "VO 2", () => {
         this.sponge.startVO("2",this);
      });
      new LabelButton(this, this.cameras.main.width / 2, this.cameras.main.height / 2 + 400, "VO 3", () => {
         this.sponge.startVO("3",this);
      });
      new LabelButton(this, this.cameras.main.width / 2, this.cameras.main.height / 2 + 500, "VO 4", () => {
         this.sponge.startVO("4",this);
      });

   }

   startTest(): void {

      if (this.startButton)
         this.startButton.destroy();

      this.resultsText = this.add.text(10, 10, "running tests...\n\n", { fontSize: 18 });
      // when scene is first loaded.
      console.log("TestScene::create");

      this.add.image(this.cameras.main.centerX, this.cameras.main.centerY + 60, "logo-sponge").setScale(0.5);
      this.add.image(this.cameras.main.centerX, this.cameras.main.centerY + 180, "logo-phaser");


      this._results.device = this.systemInformation();
      this._results.device.info.userAgent = navigator.userAgent;


      this._results.SCORM = this.SCORM();
      this._results.storyline = this.storyline();


      //delay this so we test auth of lazy load.
      this.customFeatures();


      //bench mark
      this.benchmarkDevice();

   }

   private benchmarkDevice() {

      console.log("benchmark::start");


      try {
         this.matter.world.setBounds(0, 0, this.cameras.main.width, this.cameras.main.height, 32, true, true, false, true);

      } catch (e) {
         console.warn("error setting matter world bounds", e);
      }

      console.log("benchmark::setBounds");

      this._results.benchmark = {
         success: true,
         info: {
            fps: [],
            complete: false
         }
      }


      this._dogs = this.add.container(0, 0);

      console.log("benchmark::container");


      this.events.on("next-benchmark", () => {



         console.log("next-benchmark");

         if (this._benchmarkTimer !== 0) {

            //time taken
            const fps = (3000 / Math.floor(this.time.now - this._benchmarkTimer)) * 60;


            this._results.benchmark.info.fps.push(fps);
         }
         this._benchmarkTimer = this.time.now;

         this._dogs.removeAll(true);

         const benchmark = this._benchMarkNumbers[this._benchmarkCounter];
         this._benchmarkCounter++;

         if (this._benchmarkCounter > this._benchMarkNumbers.length || (this._benchmarkCounter + 1 > this._benchMarkNumbers.length && this.game.device.browser.ieVersion === 11)) {
            console.log("benchmark::finish");

            this.events.off("next-benchmark");
            this._results.benchmark.info.complete = true
            this.showPopup();



            return;
         }

         this.sound.play('mp3');


         for (let i = 0; i < benchmark.quantity; i++) {
            const dog = this.matter.add.image(Phaser.Math.Between(0, this.cameras.main.width), Phaser.Math.Between(0, this.cameras.main.height), 'png');
            dog.setCircle(20);
            dog.setFriction(0.005);
            dog.setBounce(1);
            dog.setScale(benchmark.scale);
            this._dogs.add(dog);
         }
      });


      this.benchmarkEvent = this.time.addEvent({
         delay: 3000,
         startAt: 2999,
         loop: true,
         callback: () => {
            this.events.emit("next-benchmark");
         },
         callbackScope: this

      })


   }

   private showPopup() {
      this.sponge.html.launchPopup("test", () => {
         this._results.popup = { success: true, info: {} };
      });

      this.time.delayedCall(10000, () => {
         try {
            document.getElementById("popup-close-button").click();
            this._results.popup.info.autoDissmissed = true;
         } catch (e) {
            console.warn(e);
         }
      }, undefined, this);
   }

   private finishTests() {
      this._complete = true;
      console.log("Test Results:", this._results);

      const resText = `
Device:        ${this._results.device.success ? "success" : "potential issues"}
SCORM:         ${this._results.SCORM.success ? "success" : "not connected"}
Storyline:     ${this._results.storyline.success ? "success" : "potential issues"}
Benchmark:     ${this._results.benchmark.success ? "success" : "potential issues"}
File loading:  ${this._results.load.success ? "success" : "potential issues"}
HTML Popup:    ${this._results.popup.success ? "success" : "potential issues"}

--------------------------------

Tests complete, please use the 
generated JSON file (which should 
have downloaded), to report 
test results to Sponge.`

      this.resultsText.text = resText;





      const filename = "results.json";
      const data = JSON.stringify(this._results, null, 2);
      const blob = new Blob([data], { type: 'application/json' });
      if (window.navigator.msSaveOrOpenBlob) {
         window.navigator.msSaveBlob(blob, filename);
      }
      else {
         const downloadElement: HTMLAnchorElement = document.createElement('a');
         downloadElement.setAttribute("href", window.URL.createObjectURL(blob));
         downloadElement.setAttribute("download", "results.json");
         downloadElement.click(); //this to auto download the test results.


      }

   }

   private storyline(): TestResult {
      const log: any = {};

      log.get = this.sponge.getStoryline('scenario');
      this.sponge.setStoryline("testvariable", "SPONGE");
      log.set = this.sponge.getStoryline('testvariable');





      if (log.set && log.set === 'SPONGE') {
         return { success: true, info: log }
      } else {
         return { success: false, info: log }
      }



   }

   private SCORM(): TestResult {

      if (this.sponge.tracking._scorm === undefined) {
         return { success: false, info: "SCORM disabled" }
      }


      const log: any = {};
      log.connect = this.sponge.tracking._scorm.connected;

      if (log.connect) {

         //set completion & score
         this.sponge.tracking.complete(0.79);

         //set save data
         this.sponge.tracking.save();


         try {
            log.suspend = this.sponge.tracking._scorm.suspendData;
            console.log("log.susspend");
            log.completionStatus = this.sponge.tracking._scorm.get("cmi.core.lesson_status");
            console.log("log.completionStatus");

            log.lessonStatus = this.sponge.tracking._scorm.get("cmi.completion_status");
            console.log("log.lessonStatus");

            log.score = this.sponge.tracking._scorm.get("cmi.completion_status");

            console.log("log.score");

            log.version = this.sponge.tracking._scorm.version;
            console.log("log.version");



            log.scoreRaw = this.sponge.tracking._scorm.get("cmi.core.score.raw");
            console.log("log.scoreRaw");

            log.scoreScaled = this.sponge.tracking._scorm.get("cmi.score.scaled");
            console.log("log.scoreScaled");


            log.interactionCount = this.sponge.tracking._scorm.get("cmi.interactions._count")
            console.log("log.interactionCount");

         } catch (e) {
            console.warn("errror", e);
         }

         return { success: true, info: log }

      } else {
         return { success: false, info: this.sponge.tracking._scorm.version }

      }
   }

   private systemInformation(): TestResult {

      return {
         success: true,
         info: this.game.device
      };
   }

   private customFeatures() {

      console.log("customFeatures::start");



      this.load.on('complete', (load: Phaser.Loader.LoaderPlugin, totalComplete: number, totalFailed: number) => {
         this._results.load = {
            success: totalFailed === 0,
            info: this.loadTests
         }
      });



      //test audio loading TODO: check working?
      this.load.audio('wav', TestWav);
      this.load.audio('m4a', Testm4a);
      this.load.audio('ogg', TestOGG);
      this.load.audio('aac', TestAAC);


      //test load of json files
      this.load.json("json", TestJSON);

      this.load.text([
         { key: "ttf", url: TestTTF },
         { key: "woff", url: TestWOFF },
         { key: "woff2", url: TestWOFF2 },
         { key: "otf", url: TestOTF },
      ]);

      // test cross domain requests
      this.load.image("crossdomain-image", "//i.imgur.com/SmYfo2m.jpg")


      //test text file loading
      this.load.xml("xml", TestXML);

      //test SVG ie 11 no supported.
      if (this.game.device.browser.ieVersion != 11) {
         this.load.svg("svg", TestSVG);
         this.loadTests["svg"] = false;
      }

      //test other image files
      this.load.image("jpg", TestJPG);



      this.load.video("mp4", TestMP4);
      this.load.video("WebM", TestWebM);


      //finally start the loader
      this.load.start();

      console.log("customFeatures::end");

   }

   update(time: number, delta: number) {
      if (!this._complete && this._results && this._results.device && this._results.SCORM && this._results.load && this._results.benchmark && this._results.benchmark.info.complete && this._results.popup) {
         this.finishTests();
      }

      if (this._fps) {
         this._fps.push(Math.round(1000 / delta));
      }

   }


   render(): void {
      //custom rendering here.

   }

   wake(): void {
      // when the scene has previously been "sleeped" this is called instead of create when re-visiting

   }
   sleep(): void {
      // when switching away from this scene to another.
   }

   shutdown(): void {
      // drop references to anything we have in create
      super.shutdown();
   }
}
